import React, { useState, useRef, useEffect } from 'react'
import { withStyles, ClassNameMap } from '@mui/styles'
import stylesheet from '../detail-container.stylesheet'
import {
	Box,
	Dialog, DialogContent, DialogTitle, Grid, IconButton, LinearProgress, Typography,
} from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Draggable from "react-draggable"
import EmptyCardComponent from './empty-card.component';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { PatientService } from '../../../../services/patient.service';

interface IProps {
	open: boolean
	handleClose: any
	input: any
	classes: ClassNameMap
}

const RestrictedMedDialogComponent: React.FC<IProps> = ({ open, handleClose, input, classes }) => {
	const conextRef = useRef(null) as any
	const patientDetail = useSelector((state: RootState) => state.patientDetail.patientDetail)
	const patientService = new PatientService()
	const [loading, setLoading] = useState(false)
	const [restrictedMed, setRestrictedMed] = useState({} as any)

	useEffect(() => {
		getRestrictedMed()
	}, [])

	const getRestrictedMed = async () => {
		setLoading(true)
		input?.id && patientService.getRestrictedMed(patientDetail?.id, input?.id, input?.type, input?.propagation).then((response: any) => {
			if (Object.keys(response?.data).length > 0) {
				setRestrictedMed(response?.data || {})
			}
			setLoading(false)
		}).catch(() => setLoading(false))
	}

	return <>
		{open &&
			<Draggable ref={conextRef} defaultPosition={{ x: 80, y: 20 }} handle='.med-rest-dialog'>
				<Dialog
					id={`med-rest-${input?.name}}`}
					fullWidth={true}
					maxWidth={false}
					PaperProps={{ sx: { width: '380px' } }}
					open={open}
					onClose={handleClose}
					hideBackdrop
					disableScrollLock
					sx={{
						position: "absolute",
						left: '15%',
						top: '12%'
					}}
				>
					<DialogTitle className={classes.contextualHelpHeader} classes={{ root: 'med-rest-dialog' }} sx={{ py: 0.5, px: 1.5 }}>
						<Grid container justifyContent="space-between" alignItems="center">
							<Grid item>
								<Typography color="textSecondary" sx={{ fontSize: '0.65rem', lineHeight: 1.2 }}>
									{`Med restriction / Treatments`}
								</Typography>
								<Typography id="modal-modal-title" sx={{ fontSize: '0.85rem', fontWeight: 600, lineHeight: 1.3 }}>
									{input?.name}
								</Typography>
							</Grid>
							<Grid item>
								<IconButton size="small" onClick={() => handleClose()} sx={{ p: 0.3 }}>
									<CloseOutlinedIcon sx={{ fontSize: '1rem' }} />
								</IconButton>
							</Grid>
						</Grid>
					</DialogTitle>
					{loading && <LinearProgress />}
					<DialogContent className={classes.dialogHeaderBox} sx={{ py: 0.5, px: 1.5 }}>
						{Object.keys(restrictedMed)?.length > 0 &&
							(Object.keys(restrictedMed?.patient_aa_forms)?.length > 0 ||
								Object.keys(restrictedMed?.aa_forms)?.length > 0)
							? <Grid container direction="column" spacing={0.3} className={classes.dialogHeader} sx={{ padding: '0.2rem 0 !important' }}>
								<Grid item className={classes.fullWidth}>
									{[...restrictedMed?.patient_aa_forms || [], ...restrictedMed?.aa_forms || []]
										?.sort()?.map((item: any) => (
											<Grid item key={item}>
												<Typography key={item} sx={{ fontSize: '0.7rem', lineHeight: 1.3 }}>{item}{restrictedMed?.patient_aa_forms?.find((i: any) => i === item) ? ' *' : ''}
												</Typography>
											</Grid>
										))}
								</Grid>
							</Grid>
							: <Box pt={1}><EmptyCardComponent /></Box>
						}
					</DialogContent>
				</Dialog>
			</Draggable>
		}
	</>
}

export default withStyles(stylesheet)(RestrictedMedDialogComponent)